import  employeeCost from './employee-costs'

const state = {
  ...employeeCost
}

export default state
